export const config = {
    title: '敬在产品-全面支持国产化信创适配',
    desc: '2025年国家电子政务网安全保障达到新水平，全面落实信息安全和信息系统等级分级保护制度',
    companyDesc: '2022年1月6日，国家发改委公布了《“十四五"推进国家政务信息化规划》明确2022-2025年将开启新一轮数字经济建设周 期。提出：“到2025年国家电子政务网安全保障达到新水平，全面落实信息安全和信息系统等级分级保护制度，基本实现政务信息化安全可靠应用，确保政务信息化建设和应用全流程安全可靠”。为加快推进国内信创产业，我国提出“2+8”体系，其中医疗行业位列国计民生八大行业之中，各医疗行业各单位也积极开展了医疗信创部署工作，积极推动信创行业在医疗领域的发展。',
    imgUrl: require('@/assets/images/qualification_honor/img_company_tec.svg'),
    contentDesc: '敬在HRP系列产品已完成对国产操作系统、数据库、中间件、国产芯片的全面支持',
    contentDescMore: '作为医院智慧运营管理领域领导厂商，敬在信息积极响应国家“新基建”发展战略，优化系统流程，提高产品服务，增强数据安全，不断探索和积极构建信创生态圈。合作包括鲲鹏、飞腾、海光、兆芯、龙芯、申威，海光、Gauss、达梦、南大通用、中标、银河麒麟、统信、Euler、东方通等诸多厂商，已获得全方位的适配认证证书。在信创适配认证方面，敬在HRP系列产品已完成对国产操作系统、数据库、中间件、国产芯片的全面支持，软硬件配合，深度调优，生态之间积极协同、共同发展。可满足医院信创需求，助力医院高质量发展，构建中国本土医院智慧管理新形态！',
    honorTitle: '资质荣誉',
    honorImg: require("@/assets/images/adaptationCert/02.png"),
    honorImgList: [
        { src: require('@/assets/images/qualification_honor/国家专精特新企业.svg'), desc: '国家专精特新企业' },
        { src: require('@/assets/images/qualification_honor/国家高新技术企业.svg'), desc: '国家高新技术企业' },
        { src: require('@/assets/images/qualification_honor/国家双软认证企业.svg'), desc: '国家双软认证企业' },
        { src: require('@/assets/images/qualification_honor/ISO证书.svg'), desc: 'ISO证书' },
        { src: require('@/assets/images/qualification_honor/企业信用等级.svg'), desc: '企业信用等级' },
        { src: require('@/assets/images/qualification_honor/IEC证书.svg'), desc: 'IEC证书' },
        { src: require('@/assets/images/qualification_honor/企业信用评分证书.svg'), desc: '企业信用评分证书' },
        { src: require('@/assets/images/qualification_honor/荣誉证书.svg'), desc: '荣誉证书' },
        { src: require('@/assets/images/qualification_honor/软件产品登记测试报告.svg'), desc: '软件产品登记测试报告' },

    ]
}
